// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d0f5c453","455":"7f759fa2"}[chunkId] + ".chunk.js";
};